import type {
  UiNotificationCenterTemplate,
  ApiNotificationCenter,
} from '../../schemas/notificationCenter.schema';

export function mapNotificationCenterTemplateFromApi(
  api: ApiNotificationCenter,
): UiNotificationCenterTemplate {
  return {
    id: api.id,
    createdAt: api.createdAt,
    customDates: api.customDates,
    endDate: api.endDate,
    organizationId: api.organizationId,
    recurrenceInterval: api.recurrenceInterval,
    recurrenceType: api.recurrenceType,
    sendVia: api.sendVia,
    startDate: api.startDate,
    status: api.status,
    tenantId: api.tenantId,
    translations: api.translations.map((t) => ({
      id: t.id,
      body: t.body,
      locale: t.locale,
      title: t.title,
    })),
    updatedAt: api.updatedAt,
  };
}
